export default __webpack_public_path__ + "static/media/sponsor-gridconnect.4b265673.png";